import React from "react";
import "./partnership.css";

import { usePartnership } from "./hooks/usePartnership";

import FilterBar from "./components/Filter/FilterBar";
import StatsGrid from "./components/StatsGrid/StatsGrid";
import ProfitPie from "./components/ProfitPie/ProfitPie";

import WithdrawalHistory from "./components/Withdrawal/WithdrawalHistory";
import Withdrawal from "./components/Withdrawal/Withdrawal";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from "chart.js";

import { arrayUnion, doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebaseConfig";

ChartJS.register(ArcElement, Tooltip, Legend);

const Partnership = ({ showToast, userId }) => {

  const {
    transactions,
    setTransactions,
    withdrawals,
    setWithdrawals,
    partners,
    selectedPartner,
    setSelectedPartner,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    stats,
    calculate
  } = usePartnership(userId);

  // ✅ FIXED FIRESTORE WRITE
  const handleAddWithdrawal = async ({
  partnerId,
  amount,
  date
}) => {

  try {

    const ref = doc(
      db,
      "users",
      userId,
      "partners",
      partnerId
    );

    const newWithdrawal = {
      partnerId,
      partnerName: selectedPartner.name,
      amount,
      date
    };

        await updateDoc(ref, {
      withdrawals: arrayUnion(newWithdrawal)
    });

    // ✅ instant UI update
    setWithdrawals(prev => [
      ...prev,
      newWithdrawal
    ]);

    showToast(
      "Withdrawal added successfully",
      "success"
    );

    return true;

  } catch (err) {
    showToast(
      "Failed to add withdrawal",
      "error"
    );

    throw err;
  }
};
  return (
    <div className="partnership">
      <h1>Partnership</h1>

      <FilterBar
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        selectedPartner={selectedPartner}
        setSelectedPartner={setSelectedPartner}
        partners={partners}
        onCalculate={calculate}
      />

      <StatsGrid stats={stats} />
<Withdrawal
        selectedPartner={selectedPartner}
        stats={stats}
        onAddWithdrawal={handleAddWithdrawal}
        showToast={showToast}
      />

      <WithdrawalHistory
        withdrawals={withdrawals}
        selectedPartner={selectedPartner}
      />
      <ProfitPie
        stats={stats}
        selectedPartner={selectedPartner}
        transactions={transactions}
      />

      
    </div>
  );
};

export default Partnership;